import { authenticatedFetchJSON } from '../utils/authenticatedFetch';

export interface ChatContext {
    incidents?: any[];
    reports?: any[];
    samples?: any[];
    activeProject?: string;
    pageName?: string;
}

export const chatWithAI = async (query: string, context: ChatContext): Promise<string> => {
    try {
        const response = await authenticatedFetchJSON<string>('/api/agents/chat', {
            method: 'POST',
            body: JSON.stringify({
                query,
                context: {
                    ...context,
                    source: 'magnus-resolve-ai-assistant',
                    timestamp: new Date().toISOString()
                }
            })
        });

        return response;
    } catch (error: any) {
        console.error("Magnus Resolve Chat Error:", error);
        throw new Error(error.message || "Failed to reach Magnus AI service");
    }
};

export default {
    chatWithAI
};
